import { RecoveryItem } from './recovery-Item';


export class RecoveryViewItem extends RecoveryItem {
  isInvoiceItemGroupStart: boolean;
  isInvoiceItemIncluded: boolean;
  isNotFoundWarning: boolean;
  invoiceType: string;
  recoveryItemType: RecoveryViewItemType;

  public constructor(init?: Partial<RecoveryViewItem>) {
    super(init);
    Object.assign(this, init);
  }
}


export enum RecoveryViewItemType {
SUPPLIER_INVOICE = 'SUPPLIER_INVOICE',
REFUND = 'REFUND',
}